import { useReadContract } from "wagmi";
import { STAKE_ABI } from "@/contract/abi/stake";
import ContractAddress from "@/contract/addresses";

/**
 * Reads LAUNCH_TIME from StakeMeta contract once per session.
 * Never expires — LAUNCH_TIME is immutable after deploy.
 */
export function useLaunchTime() {
  return useReadContract({
    address: ContractAddress.STAKE,
    abi: STAKE_ABI,
    functionName: "LAUNCH_TIME",
    query: {
      staleTime: Number.POSITIVE_INFINITY,
      gcTime: Number.POSITIVE_INFINITY,
      refetchOnMount: false,
    },
  });
}
